
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const PrivacyPage: React.FC = () => {
  return (
    <div className="privacy-page py-5">
      <Container>
        <Row>
          <Col lg={8} className="mx-auto">
            <h1 className="mb-4">Privacy Policy</h1>
            <p className="text-muted mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-5">
              <h2 className="h4 mb-3">1. Information We Collect</h2>
              <h3 className="h5 mb-2">Personal Information</h3>
              <p>
                When you register for MyWeeshy, we collect information such as your name, email address, 
                username, and profile information. We may also collect payment information for premium features.
              </p>
              
              <h3 className="h5 mb-2">Usage Information</h3>
              <p>
                We collect information about how you use our service, including event data, song requests, 
                and interaction patterns to improve our platform.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">2. How We Use Your Information</h2>
              <ul>
                <li>To provide and maintain our service</li>
                <li>To notify you about changes to our service</li>
                <li>To provide customer support</li>
                <li>To gather analysis or valuable information to improve our service</li>
                <li>To monitor the usage of our service</li>
                <li>To detect, prevent and address technical issues</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">3. Information Sharing</h2>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, 
                except as described in this policy. We may share information with trusted service providers who assist us 
                in operating our website and conducting our business.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">4. Data Security</h2>
              <p>
                We implement appropriate security measures to protect your personal information against unauthorized access, 
                alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">5. Data Retention</h2>
              <p>
                We retain your personal information only for as long as necessary to provide you with our service 
                and as described in this Privacy Policy. We will also retain usage data for internal analysis purposes.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">6. Your Rights</h2>
              <p>
                You have the right to access, update, or delete the personal information we have on you. 
                You can do this by logging into your account or contacting us directly.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">7. Cookies</h2>
              <p>
                We use cookies and similar technologies to enhance your experience on our platform. 
                You can choose to disable cookies through your browser settings.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">8. Third-Party Services</h2>
              <p>
                Our service may contain links to third-party websites or services. We are not responsible for 
                the privacy practices of these third parties.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">9. Changes to Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
                the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">10. Contact Us</h2>
              <p>
                If you have any questions, requests, or complaints regarding your privacy or this policy, 
                please email us at:
              </p>
              <address>
                <strong>Deviofy FZCO</strong><br />
                DSO-THUB, Dubai Digital Park<br />
                Dubai Silicon Oasis, Building A2<br />
                Dubai, UAE<br />
                <a href="mailto:info@deviofy.com">info@deviofy.com</a>
              </address>
            </section>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPage;
